module.exports = __webpack_public_path__ + "img/approve.d22235cb.svg";